import axios from 'axios'

export default {
  sendSalesRequest (message) {
    const config = { }
    return axios.post('/mail/salessupport', message, config)
      .then(response => {
        return response.data
      })
  },
  sendUserRequest (message) {
    const config = { }
    return axios.post('/mail/usersupport', message, config)
      .then(response => {
        return response.data
      })
  }
}
